import * as React from 'react';
import { useState } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import {
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@mui/material';
import { useCurrentInstanceType } from '../Helper';
import '../Styles.css'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

/**
 * Modify ASG Component
 * @param {*} param0 
 * @returns 
 */
export default function ScheduleIdle({ handleClose, onSave, instanceData }) {

    const [idleDuration, setIdleDuration] = useState(1);

    const idleDaysArray = Array.from({ length: 14 }, (n, index) => index + 1)
    const { type } = useCurrentInstanceType()

    return (
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={true}
            slotProps={{
                backdrop: {
                    sx: {
                        backgroundColor: 'rgba(0, 0, 0, 0.65)',
                    },
                },
            }}
            PaperProps={{
                sx: {
                    borderRadius: '29px',
                    border: '1px solid #BDE0FF',
                    background: '#FFF',
                    boxShadow: '0px 4px 20px 0px #E3F0FC',
                    padding: 4,
                },
            }}
            className='schedule-modal'
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                <Typography className='heading' variant="h5">Schedule Idle</Typography>
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: '#A9B3BB',
                }}
            >
                <img src='../../close-icon.svg' alt='Close Icon' width={'26px'} height={'26px'} />
            </IconButton>
            <DialogContent>
                <Grid container spacing={1} rowGap={'10px'} >
                    <Grid item xs={12}>
                        <TableContainer className='table-container'>
                            <Table size='small'>
                                <TableHead>
                                    {instanceData && (
                                        <TableRow>
                                            <TableCell className='no-bottom-border'><Typography variant='h6' className='table-th-cell'>Instance</Typography></TableCell>
                                            <TableCell className='no-bottom-border'><Typography variant='h6' className='table-th-cell'>Idle Days</Typography></TableCell>
                                        </TableRow>
                                    )}
                                </TableHead>
                                <TableBody>
                                    {instanceData && instanceData.map(item => (
                                        <TableRow key={item['id']}>
                                            <TableCell className='no-bottom-border'><Typography variant='subtitle2' textAlign={'center'}>{item['InstanceId'] ?? item['id']}</Typography></TableCell>
                                            <TableCell className='no-bottom-border'><Typography variant='subtitle2' textAlign={'center'}>{item['IdleDays']}</Typography></TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>

                    {/* <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            readonly
                            disabled
                            label="Maximum Size"
                            size='small'
                            type='number'
                            value={instanceData?.[0]?.['MaxSize']}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Minimum Size"
                            size='small'
                            type='number'
                            value={minimumCount}
                            onChange={(e) => setMinimumCount(prev => {
                                return (e['target']['value'] < 0) ? 0 : e['target']['value']
                            })}
                        />
                    </Grid> */}
                    <Grid item xs={12}>
                        <FormControl size="small" fullWidth sx={{
                            '& .MuiOutlinedInput-root': {
                                backgroundColor: 'rgba(217, 217, 217, 0.00)',
                                '& fieldset': {
                                    borderColor: '#A7BBCE',
                                    borderRadius: '7px'
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: '#425466', //Label color (default)
                            },
                            '& .MuiSelect-icon': {
                                color: '#506C84', //Dropdown arrow icon
                            },
                            '& .MuiSelect-select': {
                                color: '#425466', //Selected value color
                            },
                        }}>
                            <InputLabel id="demo-simple-select-label">Idle Duration (in Days)</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                value={idleDuration}
                                label="Idle Duration (in Days)"
                                placeholder='Number of days'
                                onChange={(e) => setIdleDuration(e['target']['value'])}
                            >
                                {idleDaysArray.map(r => (
                                    <MenuItem key={r} value={r}>{r}</MenuItem>
                                ))}
                            </Select>
                            {idleDuration && <FormHelperText style={{ color: '#76818B' }}>
                                {`Note: Selected instances will idle for ${idleDuration} days, then auto-stop.`}
                            </FormHelperText>}
                        </FormControl>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    className='submit-btn'
                    onClick={() => onSave({
                        idleDuration
                    })}
                    variant='outlined'
                >
                    Save
                </Button>
            </DialogActions>
        </BootstrapDialog>
    );
}